import type { ComponentPropsWithoutRef } from 'react';

type Props = Omit<ComponentPropsWithoutRef<'svg'>, 'xmlns' | 'version' | 'viewBox' | 'className'>;

const icon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="16 16 32 32"
    className="icon"
    {...props}
  >
    <path d="M32.105,26.297c-3.863-9.098-14.842-6.841-14.914,3.719c-0.04,5.799,3.176,8.808,14.937,16.919 c10.688-7.172,14.945-11.183,14.905-16.982C46.96,19.367,35.789,17.562,32.105,26.297z" />
  </svg>
);
export default icon;
